import { CreditUsageType } from '@aibees/shared/definition';
import type { IconName } from '@aibees/shared/components/icon/types';

export interface CreditCategory {
  title: string;
  icon: IconName;
  types: CreditUsageType[];
}

export const CREDIT_CATEGORY_DEFINITIONS: CreditCategory[] = [
  {
    title: 'Contact Storage',
    icon: 'database-search-outline',
    types: [
      CreditUsageType.CONTACT_STORAGE_BASIC,
      CreditUsageType.CONTACT_STORAGE_AI,
    ],
  },
  {
    title: 'Company Storage',
    icon: 'database-search-outline',
    types: [
      CreditUsageType.ACCOUNT_STORAGE_BASIC,
      CreditUsageType.ACCOUNT_STORAGE_AI,
    ],
  },
  {
    title: 'Saved Records',
    icon: 'bookmark-fill',
    types: [
      CreditUsageType.CONTACT_JOB_CHANGE,
      CreditUsageType.CONTACT_PROFILE_UPDATE,
      // TODO: add "Saved Company — Data Update" once a matching enum value exists
      CreditUsageType.CONTACT_EMAIL_REVERIFICATION,
    ],
  },
  {
    title: 'Contact Discovery',
    icon: 'check-circle-outline',
    types: [
      CreditUsageType.CONTACT_EMAIL_FINDING,
      CreditUsageType.CONTACT_PHONE_FINDING,
      CreditUsageType.CONTACT_PROFILE_REVEAL,
    ],
  },
  {
    title: 'AI Insight',
    icon: 'outline-auto-awesome',
    types: [
      CreditUsageType.CONTACT_ANALYSIS_REVEAL,
      CreditUsageType.CONTACT_ANALYSIS_UPDATE,
    ],
  },
  {
    title: 'CSV Enrichment',
    icon: 'copy-outline',
    types: [
      CreditUsageType.CONTACT_STORAGE_ENRICH,
      CreditUsageType.ACCOUNT_STORAGE_ENRICH,
    ],
  },
];
